import WebSocket from 'isomorphic-ws'

export default function initWebsocket ({ vm, hostname }) {
  const develWsUrl = process.env.VUE_APP_DEVEL_WS_URL 
    ? process.env.VUE_APP_DEVEL_WS_URL 
                      : 'ws://localhost:8000/api'
  const wsUrl = process.env.NODE_ENV === 'production' 
                  ? `wss://${hostname}/api` 
                  : develWsUrl
  const token = vm.$cookies.get('session')
  const ws = new WebSocket(`${wsUrl}?token=${token}`)

  ws.onmessage = (data) => {
    // console.log('WEBSOCKET RECEIVED', data)
    const msg = data.data // {"/test/lublin/odpojovace/27/status"=>"22u"}
    vm.$store.commit('receiveFromWebSocket', { msg, vm: vm })
  }

  return ws
}
